import React from 'react'
import './TaskViews.scss'

interface RecurringViewProps {
  lifeSpace?: 'personal' | 'work' | 'home' | 'all'
}

export const RecurringView: React.FC<RecurringViewProps> = () => {
  return (
    <div className="task-view">
      <div className="task-view__header">
        <div className="task-view__title-section">
          <h2 className="task-view__title">Wiederkehrend</h2>
        </div>
      </div>
    </div>
  )
}
